import React from 'react';
import { Avatar } from 'antd';
import { connect } from 'react-redux';
import { Layout } from 'components';
import { axius, func, links } from 'helpers';
import Link from 'next/link';
import Custom404 from 'pages/404';

const Results = (props) => {

    const { org, award, results } = props;

    React.useEffect(() => {
        // console.log(award);
    }, []);

    const image = award.logo ? award.logo_link : org.logo_link;

    return (
        <React.Fragment>
            {award.uuid ? (
                <Layout
                    Head={{
                        url: links.result(award, true).as,
                        title: `Top 5 results for ${award.name}`,
                        image,
                        description: `${award.name}. ${org.description}`,
                    }}
                >
                    <main className="bg-greys pb-30">
                        <div className={`entry-header entry-header-style-2 pb-80 pt-80 mb-50 text-white`}
                            style={{ backgroundImage: `url('assets/img/bg-results.jpg?v=${func.app.version}')`, backgroundAttachment: 'fixed' }}
                        >
                            <div className="container container-sm entry-header-content">
                                <div className="entry-meta align-items-center meta-2 font-small color-white">
                                    <div className="mb-5 text-white">
                                        <div className="author-avatar">
                                            <div className="img-bg img-circle"
                                                style={{ backgroundImage: `url('${image}')`, height: 100, width: 100, border: '2px solid #fff', margin: '0 auto' }}
                                            >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <h1 className="entry-title font-weight-900 text-shadow">{award.name}</h1>
                                <p className="mb-50s">
                                    <Link as={links.award(award).as} href={links.award(award).href}>
                                        <a className="text-white">{award.name}</a>
                                    </Link>
                                </p>
                            </div>
                        </div>

                        <div className="archive-header pt-50s text-center">
                            <div className="container">
                                <h3 className="font-weight-900">{func.intl('Text.Top5Results', 'Top 5 results')}</h3>
                                <div className="bt-1s border-color-1s mt-20 mb-30"></div>
                            </div>
                        </div>

                        <div className="container">
                            {results.length > 0 && award.preferences.show_results ? (
                                <div className="row">
                                    <div className="col-lg-3"></div>
                                    <div className="col-lg-6">
                                        <table className="table">
                                            <tbody>
                                                {func.chunk(results, 5)[0].map((row, i) => {
                                                    i = i + 1;
                                                    return (
                                                        <tr key={`nominee-${i}`}>
                                                            <td width="45px">
                                                                <Avatar src={row.nominee.avatar ? row.nominee.avatar_link : award.logo_link} size={45} />
                                                            </td>
                                                            <td>
                                                                <span>{i++}. {row.nominee.name}</span>
                                                            </td>
                                                            <td align="right">
                                                                <span className="font-weight-900">{func.numberFormat(row.votes)}</span>
                                                            </td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="col-lg-3"></div>
                                </div>
                            ) : (
                                <div className="text-center">
                                        {func.intl('Text.NoResults', 'There are no votes recorded for')} <span className="font-weight-900">{award.name}</span>
                                </div>
                            )}
                        </div>
                    </main>
                </Layout>
            ) : (
                <Custom404 />
            )}
        </React.Fragment>
    )
}


export async function getServerSideProps(ctx) {
    const { result } = ctx.query;
    const id = parseInt((result || '').split('.')[1]);
    const resAwd = await axius.get(`awards/${id}`, {});
    const resRes = resAwd.status === 200 ? await axius.get(`votes/results`, { award: resAwd.data?.uuid, }) : {};
    return {
        props: {
            org: resAwd.award?.organisation || {},
            award: resAwd.data || {},
            results: resRes.data || [],
        },
    }
};

const mapStateToProps = (state) => ({
    _data: state.data,
});

export default connect(mapStateToProps, {})(Results);